import React, { useRef } from 'react';

import ModalAiArtist from './ModalAiArtist';

import MiguelTamaraImg from '../../../../../Images/gallery/ai-services/miguel-tamara.png';
import Video1 from '../../../../../Images/gallery/ai-services/miguel-tamara/video-1.png';
import Video2 from '../../../../../Images/gallery/ai-services/miguel-tamara/video-2.png';
import Video3 from '../../../../../Images/gallery/ai-services/miguel-tamara/video-3.png';

import {
  MiguelTamara_Title,
  MiguelTamara_Text,
  MiguelTamara_Video1,
  MiguelTamara_Video2,
  MiguelTamara_Video3,
} from '../../../../../utils/EN/Modals/aiArtists';

const ModalMiguelTamara = () => {
  return (
    <>
      <ModalAiArtist
        id="artist-miguel-tamara"
        artistImage={MiguelTamaraImg}
        artistName="Tamara & Miguel"
        artistTitle={MiguelTamara_Title}
        artisText={MiguelTamara_Text}
        videoRef1={'miguel-tamara-video-1'}
        videoBg1={Video1}
        videoText1={MiguelTamara_Video1}
        videoRef2={'miguel-tamara-video-2'}
        videoBg2={Video2}
        videoText2={MiguelTamara_Video2}
        videoRef3={'miguel-tamara-video-3'}
        videoBg3={Video3}
        videoText3={MiguelTamara_Video3}
      />
    </>
  );
};

export default ModalMiguelTamara;
